import React from 'react'
import { usePrismicDocumentsByUIDs } from '@prismicio/react'

import { RelatedArticles } from './RelatedArticles'

export const RelatedFetch = ({ data, value }) => {
	const [documents, { state }] = usePrismicDocumentsByUIDs('article', data)

	return state !== 'loaded'
		? null
		: <RelatedArticles data={documents} value={value} />
};

